import React from "react";
import ApplicationHeader from "../../../application/ApplicationHeader";
import { Container } from "@material-ui/core";
import ApplicationPanel from "../../../application/ApplicationPanel";
import SftpAccountBrowse from "./SftpAccountBrowse";
import { ReactQueryDevtools } from "react-query/devtools";
import { QueryClient, QueryClientProvider } from "react-query";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: Infinity,
    },
  },
});

const ManageSftpAccounts = () => {
  return (
    <Container id="manage-sftp-accounts">
      <ApplicationHeader />

      <ApplicationPanel>
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools initialIsOpen={false} />

          <SftpAccountBrowse />
        </QueryClientProvider>
      </ApplicationPanel>
    </Container>
  );
};

export default ManageSftpAccounts;
